// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__9o4rl","colMaxWidth":"Table_colMaxWidth__3G_pV"};